module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-group"
  }, [_vm._l((_vm.aCardGroup), function(item, index) {
    return [(index != 0) ? _c('div', {
      staticClass: "jiantou"
    }, [_c('img', {
      attrs: {
        "src": _vm.img.jiantou
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('img', {
      attrs: {
        "src": item.img
      },
      on: {
        "mouseover": function($event) {
          _vm.fnImageHover(item, index)
        },
        "mouseout": function($event) {
          _vm.fnImageHover(item, index)
        }
      }
    })])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h4', [_vm._v(_vm._s(_vm.sDesc.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sDesc.desc))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_vm._v("查看详情")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("产品智能化进阶")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("每个版本都是一个弹性方案都可无缝升级，从智能控制到运营规划，Qiot方案全线满足")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3dafc26b"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/page_2.vue
// module id = 774
// module chunks = 1